var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-input", {
    staticClass: "full-width",
    attrs: {
      type: "textarea",
      placeholder: _vm.placeholder || _vm.$t("inputText"),
      maxlength: _vm.maxlength,
      "show-word-limit": _vm.showWordLimit,
      disabled: _vm.disabled,
      rows: _vm.rows,
      resize: _vm.resize,
    },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v
      },
      expression: "id",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }